import React from "react";
import TransitionUpsellIcon from "../../../components/Icons/TransitionUpsellIcon";
import { useUserDetail } from "../../../services/user-detail/user-detail.service";

const UrgentCareTransitionCard = () => {
  const { user } = useUserDetail();

  return (
    <div className="w-full relative">
      {/* Centered Floating Icon */}
      <div className="absolute -top-6 left-1/2 transform -translate-x-1/2">
        <div className="bg-white rounded-full p-1">
          <div className="bg-orange-1 rounded-full p-1">
            <TransitionUpsellIcon />
          </div>
        </div>
      </div>

      {/* Card Content */}
      <div className="bg-white py-3 px-6 mx-2 rounded-xl pt-11">
        <div className="flex flex-col items-center gap-3 text-center">
          <div className="font-semibold text-xl">
            Changes to Your Home Hospital
          </div>
          <div className="font-semibold text-sm bg-taupe-15 px-4 py-1 w-[95%] rounded">
            <span className="capitalize">{user?.location?.locationName}</span> transitioning to Urgent Care
          </div>
          <div className="text-sm text-centerw-full rounded">
            This location’s hours and services will be changing to serve pets with urgent needs.
            To visit a GoodVets during more traditional hours,
            please update your home hospital to one of our other locations in{" "}
            <span className="capitalize">{user?.location?.city}</span>.
          </div>
        </div>
      </div>
    </div>
  );
};

export default UrgentCareTransitionCard;
